import { Component, Output, EventEmitter, ViewChild, ElementRef , CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { UserDataImportService } from "../../services/userdataimport.service";
import { ToastrService } from "ngx-toastr";
import { DownloadFileComponent } from "../downloadfile/downloadfile.component";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Component({
    selector: "usersimportfile",
    templateUrl: "./usersimportfile.component.html",
    standalone: true,
    imports: [CommonModule, DownloadFileComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UsersImportFileComponent {
    @Output() uploadCompleteEvent = new EventEmitter();
    uploadErrors: string[] = [];
    showValidationErrors: boolean = false;
    showInput: boolean = false;
    @ViewChild("fileUpload") fileUploadCtrl: ElementRef;
    @ViewChild("download") fileDownload: DownloadFileComponent;
    constructor(private httpClient: HttpClient, private toastr: ToastrService, private userDataImportService: UserDataImportService, private sanitizer: DomSanitizer) {
    }

    fileChange(event: any): void {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: any = fileList[0];
            let formData: FormData = new FormData();
            formData.append("fileUpload", file, file.name);
            this.showValidationErrors = false;
            this.userDataImportService.importFile(formData).subscribe(
                (res: Blob) => {
                    // Check if the response is an Excel file (success) or validation errors
                    if (res && res.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                        // Successful upload - Excel file returned for download with errors
                        this.fileDownload.downloadExcel("DataImportTemplate", res);
                        this.toastr.error("Please check the downloaded file for errors");
                    }
                    else if (res && res.type === "application/json") {
                        // Parse JSON response for validation errors
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            try {
                                const jsonData = JSON.parse(reader.result as string);
                                this.uploadErrors = jsonData;
                                this.toastr.error("File cannot be uploaded");
                            } catch (parseErr) {
                                this.toastr.error("Error processing response");
                            }
                        };
                        reader.readAsText(res);
                    }
                    else {
                        // Successful upload with no errors
                        this.toastr.success("File upload successful");
                    }
                    this.fileUploadCtrl.nativeElement.value = "";
                    this.uploadCompleteEvent.emit();
                },
                (err) => {
                    // reset input to be able to detect file change event
                    this.toastr.error("Upload failed: " + (err.message || "Unknown error"));
                    this.fileUploadCtrl.nativeElement.value = "";
                }
            );
        }
    }
}



